import { Injectable } from "@angular/core";
import { Agente } from "@tivic-team/manager-ts/dist/mob/entities/agente.entity";
import { AgenteController } from "app/controllers/mob/agente.controller";
import { LoaderService } from "../loader.service";
import { AgenteSearch } from "./agente.search";



@Injectable()
export class AgenteService {
    constructor(
        private _agenteController: AgenteController,
        private _loaderService: LoaderService
    ) { }

    async findAgente(agenteSearch?: AgenteSearch): Promise<Agente[]> {
        return await this._agenteController.findAgente(agenteSearch && agenteSearch.getFilters() || null);
    }

    async find(agenteSearch?: AgenteSearch): Promise<Agente[]> {
        this._loaderService.show();
        return this._agenteController.find(agenteSearch && agenteSearch.getFilters() || null).finally(() => this._loaderService.hide());
    }

    async get(cdAgente:number):Promise<Agente>{
        this._loaderService.show();
        return this._agenteController.get(cdAgente).finally(() => this._loaderService.hide());
    }

    create(entity: Agente): Promise<Agente> {
        this._loaderService.show();
        return this._agenteController.create(entity).finally(() => this._loaderService.hide());
    }
    
    update(entity: Agente): Promise<Agente> {
        this._loaderService.show();
        return this._agenteController.update(entity).finally(() => this._loaderService.hide());
    }

    save(entity: Agente): Promise<Agente> {
        if (!entity.cdAgente)
          return this.create(entity)
         
        return this.update(entity)
    }
}